import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Chip } from '@mui/material';
import { useMemo } from 'react';

import useStyles from './SearchableSelect.styles';
import type { SearchableSelectButtonProps } from './SearchableSelect.types';

const SearchableSelectButton = ({
  title,
  selectedFilterOptions,
  filterOptions,
  color = 'secondary',
  ref,
  buttonLabel = 'All',
  onClick
}: SearchableSelectButtonProps) => {
  const { classes } = useStyles();
  const label = useMemo(() => {
    let labelElem = buttonLabel !== '' ? <strong>{buttonLabel}</strong> : null;

    if (selectedFilterOptions.length > 1) {
      labelElem = (
        <Chip label={`${selectedFilterOptions.length} selected`} size="small" />
      );
    } else if (selectedFilterOptions.length > 0) {
      // Fall back to the raw selected value when it has no matching entry in
      // filterOptions (e.g. a data-driven option whose count dropped to zero
      // and was excluded from the list), so the chip doesn't disappear.
      const labels = selectedFilterOptions.map((selected) => {
        const matched = filterOptions.find(
          (option) => String(option.value) === selected
        );

        return matched?.label ?? selected;
      });

      labelElem = <Chip label={labels.join(', ')} size="small" />;
    }
    return <span>{labelElem}</span>;
  }, [filterOptions, selectedFilterOptions]);

  return (
    <Button
      className={`${classes.searchableSelectButton} SearchableSelect-button`}
      variant="outlined"
      color={color}
      onClick={onClick}
      ref={ref}
      endIcon={<FontAwesomeIcon icon={faAngleDown} />}
    >
      {title !== '' ? `${title}: ` : ''}
      {label}
    </Button>
  );
};

export default SearchableSelectButton;
